module.exports = __webpack_public_path__ + "img/监管.666d75b1.png";